// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selectedColor[data-v-2698f49b]{border:2px solid #4a669e}.hidden[data-v-2698f49b]{display:none}.cropperImgArea img[data-v-2698f49b]{display:block;max-width:100%}", ""]);
// Exports
module.exports = exports;
